module.exports = __webpack_public_path__ + "img/edit-icon.14bee5eb.svg";